import React, { lazy, Suspense } from 'react';

const PowerUpDirectory = lazy(() =>
  import(/* webpackChunkName: "power-up-directory" */ './PowerUpDirectory'),
);

export const LazyPowerUpDirectory: React.FunctionComponent<{
  section?: string;
  subsection?: string;
  query?: string;
}> = ({ section, subsection, query }) => {
  return (
    <Suspense fallback={null}>
      <PowerUpDirectory
        section={section}
        subsection={subsection}
        query={query}
      />
    </Suspense>
  );
};
